<script>
import GridFileCard from "./components/GridFileCard.vue";

export default {
    props: {
        allItems: {
            type: Array,
            default: [],
            required: true,
        },
        noDataTitle: {
            type: String,
            default: null,
            required: true,
        },
        classes: {
            type: String,
            required: true
        },
        increment: {
            type: Number,
            required: true
        },
        isDataLoading: {
            type: Boolean,
            required: true
        },
        onMounted: {
            type: Function,
            required: true
        },
        perpage: {
            type: Number,
            default: 12,
            required: true
        },
        showModal: {
            type: Function,
            required: true
        },
        routeType: {
            type: String,
            default: null
        },
        dataType: {
            type: String,
            default: null,
        }
    },
    components: { GridFileCard },
    computed: {
        hideScrollable() {
            if(this.perpage == 12 && this.allItems.length < 13 || this.perpage == 24 && this.allItems.length < 25 || this.perpage == 36 && this.allItems.length < 37 || this.perpage == 48 && this.allItems.length < 49) {
                return true
            }
        }
    },
    mounted() {
        let self = this
        self.onMounted('setincrement')
    }
    
};
</script>

<template>
    <div>
        <div v-if="allItems.length > 0" class="container-fluid setListHeight" :class="{scrollableBody: (allItems.length > 12), hideScrollBar: hideScrollable, gridInfiniteData: (classes == 'folders')}"> 
            <div class="row overflow-hidden">            
                <div v-for="(item, index) in allItems.slice(0, increment)" :key="index" class="col-xl-4 col-sm-6">            
                    <GridFileCard 
                        :item="item" 
                        :onMounted="onMounted"
                        :classes="classes"
                        :showModal="showModal"
                        :index="index"
                        :routeType="routeType"
                        :dataType="dataType"
                    />
                </div>
            </div>
        </div>
        <div v-else class="text-center text-secondary"><span v-html="noDataTitle"></span></div>
        <div v-if="isDataLoading"  class="col-12">
            <div class="text-center my-3">
                <a href="javascript:void(0);" class="text-success"><i class="bx bx-hourglass bx-spin me-2"></i> Loading</a>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .scrollableBody {
      overflow-y:scroll;  
    }

    .hideScrollBar::-webkit-scrollbar {
        display: none;
    }
    .hideScrollBar {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
</style>